(function() {
  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
  }
  const footerForm = document.getElementById("ContactFooter-newsletter");
  const footerEmailInput = document.getElementById("footer_NewsletterForm");
  const footerSubmitBtn = document.getElementById("Subscribe--newsletter");
  if (footerForm && footerEmailInput && footerSubmitBtn) {
    let showFooterError2 = function(message) {
      footerErrorMsg.textContent = message;
      footerErrorMsg.style.display = "block";
      footerEmailInput.setAttribute("aria-invalid", "true");
      footerEmailInput.style.borderColor = "#e02b2b";
    }, clearFooterError2 = function() {
      footerErrorMsg.style.display = "none";
      footerErrorMsg.textContent = "";
      footerEmailInput.removeAttribute("aria-invalid");
      footerEmailInput.style.borderColor = "";
    }, setFooterButtonState2 = function(enabled) {
      footerSubmitBtn.disabled = !enabled;
      footerSubmitBtn.style.cssText = enabled ? "opacity: 1; cursor: pointer; pointer-events: auto; transition: opacity 0.2s ease;" : "opacity: 1; cursor: not-allowed; pointer-events: auto; transition: opacity 0.2s ease;";
    };
    var showFooterError = showFooterError2, clearFooterError = clearFooterError2, setFooterButtonState = setFooterButtonState2;
    const oldError = document.getElementById("footer-newsletter-error");
    if (oldError) oldError.remove();
    const footerErrorMsg = document.createElement("p");
    footerErrorMsg.id = "footer-newsletter-error";
    footerErrorMsg.setAttribute("aria-live", "polite");
    footerErrorMsg.style.cssText = [
      "color: #fff",
      "font-size: 15px",
      "margin-top: 8px",
      "margin-bottom: 0",
      "display: none",
      "font-weight: normal",
      "background: transparent"
    ].join("; ");
    const fieldWrapper = footerForm.querySelector(".newsletter-form__field-wrapper");
    if (fieldWrapper) {
      fieldWrapper.insertAdjacentElement("afterend", footerErrorMsg);
    } else {
      footerForm.appendChild(footerErrorMsg);
    }
    setFooterButtonState2(false);
    footerEmailInput.addEventListener("input", function() {
      const val = footerEmailInput.value.trim();
      if (val === "") {
        clearFooterError2();
        setFooterButtonState2(false);
      } else if (isValidEmail(val)) {
        clearFooterError2();
        setFooterButtonState2(true);
      } else {
        showFooterError2("Please enter a valid email address.");
        setFooterButtonState2(false);
      }
    });
    footerEmailInput.addEventListener("blur", function() {
      const val = footerEmailInput.value.trim();
      if (val === "") {
        showFooterError2("Email address is required.");
        setFooterButtonState2(false);
      } else if (!isValidEmail(val)) {
        showFooterError2("Please enter a valid email address.");
        setFooterButtonState2(false);
      } else {
        clearFooterError2();
        setFooterButtonState2(true);
      }
    });
    footerForm.addEventListener("submit", function(e) {
      const val = footerEmailInput.value.trim();
      if (val === "" || !isValidEmail(val)) {
        e.preventDefault();
        showFooterError2(val === "" ? "Email address is required." : "Please enter a valid email address.");
        setFooterButtonState2(false);
        footerEmailInput.focus();
      } else {
        clearFooterError2();
        setFooterButtonState2(true);
      }
    });
    const footerUrlParams = new URLSearchParams(window.location.search);
    const isFooterSuccess = footerUrlParams.get("customer_posted") === "true";
    const footerHash = window.location.hash;
    if (isFooterSuccess && footerHash === "#ContactFooter-newsletter") {
      const footerSuccess = document.getElementById("ContactFooter-footer-newsletter-success");
      if (footerSuccess) {
        setTimeout(function() {
          footerSuccess.style.cssText = "transition: opacity 0.8s ease, max-height 0.8s ease, margin 0.8s ease; opacity: 0; max-height: 0; overflow: hidden; margin: 0; padding: 0;";
          setTimeout(function() {
            footerSuccess.remove();
            const cleanUrl = window.location.href.replace(/[?&]customer_posted=true/, "").replace(/#.*$/, "");
            window.history.replaceState(null, "", cleanUrl);
          }, 800);
        }, 1e4);
      }
    }
  }
  const popupForm = document.getElementById("newsletter-popup-form");
  if (popupForm) {
    let showPopupEmailError2 = function(message) {
      if (!popupEmailError) return;
      popupEmailError.textContent = message;
      popupEmailError.style.display = "block";
      popupEmailInput.style.borderColor = "#e02b2b";
      popupEmailInput.setAttribute("aria-invalid", "true");
    }, clearPopupEmailError2 = function() {
      if (!popupEmailError) return;
      popupEmailError.style.display = "none";
      popupEmailError.textContent = "";
      popupEmailInput.style.borderColor = "";
      popupEmailInput.removeAttribute("aria-invalid");
    }, showPopupNameError2 = function(message) {
      if (!popupNameError) return;
      popupNameError.textContent = message;
      popupNameError.style.display = "block";
      popupNameInput.style.borderColor = "#e02b2b";
      popupNameInput.setAttribute("aria-invalid", "true");
    }, clearPopupNameError2 = function() {
      if (!popupNameError) return;
      popupNameError.style.display = "none";
      popupNameError.textContent = "";
      popupNameInput.style.borderColor = "";
      popupNameInput.removeAttribute("aria-invalid");
    }, setPopupButtonState2 = function(enabled) {
      if (!popupSubmitBtn) return;
      popupSubmitBtn.disabled = !enabled;
      popupSubmitBtn.style.cssText = enabled ? "opacity: 1; cursor: pointer; pointer-events: auto; transition: opacity 0.2s ease;" : "opacity: 1; cursor: not-allowed; pointer-events: auto; transition: opacity 0.2s ease;";
    }, checkPopupFormValid2 = function() {
      const emailOk = popupEmailInput && isValidEmail(popupEmailInput.value.trim());
      const nameOk = popupNameInput ? popupNameInput.value.trim() !== "" : true;
      return emailOk && nameOk;
    };
    var showPopupEmailError = showPopupEmailError2, clearPopupEmailError = clearPopupEmailError2, showPopupNameError = showPopupNameError2, clearPopupNameError = clearPopupNameError2, setPopupButtonState = setPopupButtonState2, checkPopupFormValid = checkPopupFormValid2;
    popupForm.setAttribute("action", "/contact#newsletter-popup-form");
    const popupEmailInput = popupForm.querySelector('input[type="email"]');
    const popupNameInput = popupForm.querySelector('input[name="contact[name]"]');
    const popupSubmitBtn = popupForm.querySelector('button[type="submit"]');
    const popupWrapper = document.getElementById("newsletter-popup");
    let popupEmailError = null;
    let popupNameError = null;
    if (popupEmailInput) {
      popupEmailError = document.createElement("p");
      popupEmailError.style.cssText = "color: #e02b2b; font-size: 15px; margin: -5px 0 5px 0; display: none;";
      popupEmailError.setAttribute("aria-live", "polite");
      popupEmailInput.insertAdjacentElement("afterend", popupEmailError);
    }
    if (popupNameInput) {
      popupNameError = document.createElement("p");
      popupNameError.style.cssText = "color: #e02b2b; font-size: 15px; margin: -5px 0 5px 0; display: none;";
      popupNameError.setAttribute("aria-live", "polite");
      popupNameInput.insertAdjacentElement("afterend", popupNameError);
    }
    setPopupButtonState2(false);
    if (popupEmailInput) {
      popupEmailInput.addEventListener("input", function() {
        const val = popupEmailInput.value.trim();
        if (val === "") {
          clearPopupEmailError2();
        } else if (isValidEmail(val)) {
          clearPopupEmailError2();
        } else {
          showPopupEmailError2("Please enter a valid email address.");
        }
        setPopupButtonState2(checkPopupFormValid2());
      });
      popupEmailInput.addEventListener("blur", function() {
        const val = popupEmailInput.value.trim();
        if (val === "") {
          showPopupEmailError2("Email address is required.");
        } else if (!isValidEmail(val)) {
          showPopupEmailError2("Please enter a valid email address.");
        } else {
          clearPopupEmailError2();
        }
        setPopupButtonState2(checkPopupFormValid2());
      });
    }
    if (popupNameInput) {
      popupNameInput.addEventListener("input", function() {
        const val = popupNameInput.value.trim();
        if (val !== "") {
          clearPopupNameError2();
        }
        setPopupButtonState2(checkPopupFormValid2());
      });
      popupNameInput.addEventListener("blur", function() {
        const val = popupNameInput.value.trim();
        if (val === "") {
          showPopupNameError2("First name is required.");
        } else {
          clearPopupNameError2();
        }
        setPopupButtonState2(checkPopupFormValid2());
      });
    }
    popupForm.addEventListener("submit", function(e) {
      let hasError = false;
      if (popupNameInput) {
        const nameVal = popupNameInput.value.trim();
        if (nameVal === "") {
          showPopupNameError2("First name is required.");
          hasError = true;
        } else {
          clearPopupNameError2();
        }
      }
      if (popupEmailInput) {
        const emailVal = popupEmailInput.value.trim();
        if (emailVal === "") {
          showPopupEmailError2("Email address is required.");
          hasError = true;
        } else if (!isValidEmail(emailVal)) {
          showPopupEmailError2("Please enter a valid email address.");
          hasError = true;
        } else {
          clearPopupEmailError2();
        }
      }
      if (hasError) {
        e.preventDefault();
        if (popupNameInput && popupNameInput.getAttribute("aria-invalid")) {
          popupNameInput.focus();
        } else if (popupEmailInput) {
          popupEmailInput.focus();
        }
        return;
      }
      setPopupButtonState2(true);
    });
    const popupUrlParams = new URLSearchParams(window.location.search);
    const isPopupSuccess = popupUrlParams.get("customer_posted") === "true";
    const popupHash = window.location.hash;
    if (isPopupSuccess && popupHash === "#newsletter-popup-form") {
      const footerSuccess = document.getElementById("ContactFooter-footer-newsletter-success");
      if (footerSuccess) footerSuccess.style.display = "none";
    }
    if (isPopupSuccess && popupHash === "#newsletter-popup-form") {
      if (popupWrapper) {
        popupWrapper.style.display = "flex";
        if (popupForm) {
          const successMsg = document.createElement("div");
          successMsg.style.cssText = "margin-top: 24px; text-align: center;";
          successMsg.innerHTML = `<p style="font-size: 18px; font-weight: bold; margin-bottom: 8px;">🎉 You're in!</p><p style="font-size: 14px;">Thanks for subscribing. The good stuff is headed your way soon.</p>`;
          popupForm.replaceWith(successMsg);
        }
        setTimeout(function() {
          popupWrapper.style.cssText = "transition: opacity 0.8s ease; opacity: 0;";
          setTimeout(function() {
            popupWrapper.style.display = "none";
            const cleanUrl = window.location.href.replace(/[?&]customer_posted=true/, "").replace(/#.*$/, "");
            window.history.replaceState(null, "", cleanUrl);
          }, 800);
        }, 1e4);
      }
    }
  }
})();
(function() {
  const urlParams = new URLSearchParams(window.location.search);
  const isSuccess = urlParams.get("customer_posted") === "true";
  const hash = window.location.hash;
  if (isSuccess && hash === "#newsletter-popup-form") {
    const footerSuccess = document.getElementById("ContactFooter-footer-newsletter-success");
    if (footerSuccess) {
      footerSuccess.style.display = "none";
    }
  }
})();
//# sourceMappingURL=form-validation.js.map
